import { useCallback } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/sharp-solid-svg-icons/faArrowRight';
import { faArrowUpFromBracket } from '@fortawesome/sharp-solid-svg-icons/faArrowUpFromBracket';
import { faFileCsv } from '@fortawesome/sharp-solid-svg-icons/faFileCsv';
import { useHistory } from 'react-router-dom';

import { BannerStatus } from 'ui-components/components/banner-message/banner-enums';
import { BannerMessageV2 } from 'ui-components/components/banner-message/banner-message-v2';
import { Button } from 'ui-components/components/button';
import { Text, TextType } from 'ui-components/components/text';

import styles from './ftu-import-success-step.module.less';
import { messages } from './messages';
import { StepType } from '../../../../../../components/csv-import/data/types/step-type';
import { useImportContext } from '../../../../../../components/csv-import/ui/components/import-context';
import { useStepDetectiveContext } from '../../../../../../components/csv-import/ui/components/step-detective/step-detective-context';
import { BASE_ORDERS_PATH } from '../../../../../../routes/constants';

export const FtuImportSuccessStepBody = () => {
  const history = useHistory();
  const { initRequest } = useImportContext();
  const { goTo } = useStepDetectiveContext();

  const handleViewOrders = useCallback(() => {
    history.push(BASE_ORDERS_PATH);
  }, [history]);

  const handleImportAnotherFile = useCallback(() => {
    goTo(StepType.CREATE_CONFIG);
  }, [goTo]);

  return (
    <div className={styles.container}>
      <BannerMessageV2
        content={<Text textType={TextType.Paragraph} value={messages.importSuccessfulBanner} />}
        status={BannerStatus.Success}
      />

      <div className={styles.fileInfo}>
        <div className={styles.fileDisplay}>
          <FontAwesomeIcon className={styles.fileIcon} icon={faFileCsv} />
          <Text className={styles.fileName} textType={TextType.Paragraph} value={initRequest.csvFile?.name || 'Orders.store.CSV'} />
        </div>
        <Button className={styles.viewOrdersLink} onClick={handleViewOrders} theme='link'>
          <Text textType={TextType.Paragraph} value={messages.viewOrders} />
          <FontAwesomeIcon icon={faArrowRight} />
        </Button>
      </div>

      <Button className={styles.importAnotherLink} onClick={handleImportAnotherFile} theme='link'>
        <Text textType={TextType.Paragraph} value={messages.importAnotherFile} />
        <FontAwesomeIcon className={styles.uploadIcon} icon={faArrowUpFromBracket} />
      </Button>
    </div>
  );
};

export const FtuImportSuccessStepFooter = () => {
  return null;
};
